import type { SVGProps } from "react";

export const ClipboardIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className="fill-current"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.4008 3.19922C15.2844 3.19922 16.0008 3.91556 16.0008 4.79922H16.8008C17.4373 4.79922 18.0476 5.05226 18.4977 5.50234C18.9477 5.95243 19.2008 6.5627 19.2008 7.19922V18.3992C19.2008 19.0357 18.9477 19.646 18.4977 20.0961C18.0476 20.5462 17.4373 20.7992 16.8008 20.7992H7.20078C6.56426 20.7992 5.95399 20.5462 5.50391 20.0961C5.05382 19.646 4.80078 19.0357 4.80078 18.3992V7.19922C4.80078 6.5627 5.05382 5.95243 5.50391 5.50234C5.95399 5.05226 6.56426 4.79922 7.20078 4.79922H8.00078C8.00078 3.91556 8.71713 3.19922 9.60078 3.19922H14.4008ZM7.20078 6.39922C6.98861 6.39922 6.78519 6.48356 6.63516 6.63359C6.48513 6.78362 6.40078 6.98705 6.40078 7.19922V18.3992L6.40469 18.4781C6.42284 18.6613 6.50384 18.8335 6.63516 18.9648C6.78519 19.1149 6.98861 19.1992 7.20078 19.1992H16.8008C17.013 19.1992 17.2164 19.1149 17.3664 18.9648C17.5164 18.8148 17.6008 18.6114 17.6008 18.3992V7.19922C17.6008 6.98705 17.5164 6.78362 17.3664 6.63359C17.2351 6.50228 17.0629 6.42128 16.8797 6.40313L16.8008 6.39922H16.0008C16.0008 7.28287 15.2844 7.99922 14.4008 7.99922H9.60078C8.71713 7.99922 8.00078 7.28287 8.00078 6.39922H7.20078ZM9.60078 6.39922H14.4008V4.79922H9.60078V6.39922Z"
        fill="currentColor"
      />
    </svg>
  );
};
